import { useEffect } from 'react';
import { hideZendeskWidget, showZendeskWidget } from '../lib/zendeskWidget';

export default function useHideZendeskWhileMounted() {
  useEffect(() => {
    hideZendeskWidget();
    return showZendeskWidget;
  });
}
